/* MATLEON — scripts propios (vanilla, sin librerías) */
(function () {
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)');

  // Reveals al hacer scroll: un solo IntersectionObserver para todo
  var io = null;
  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal:not(.mt-visible), .mt-reveal-img:not(.mt-visible)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          // Un elemento recortado al 100% con clip-path no "intersecta": se vigila su contenedor y se revelan sus hijos
          var hijos = e.target.mtRevelar || [e.target];
          hijos.forEach(function (h) { h.classList.add('mt-visible'); });
          io.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) {
      if (el.classList.contains('mt-reveal-img') && el.parentElement) {
        var p = el.parentElement;
        if (!p.mtRevelar) { p.mtRevelar = []; io.observe(p); }
        p.mtRevelar.push(el);
      } else {
        io.observe(el);
      }
    });
  }

  // Repite el grupo hasta cubrir el ancho de pantalla y duplica todo para un bucle sin saltos.
  // La duración se multiplica por las copias: así la cinta va al mismo paso en cualquier pantalla
  // (antes, en una pantalla de 1920 px corría al doble que en una de 1024 px).
  function armarCinta(track) {
    var grupo = track.querySelector('.mt-marquee__grupo');
    if (!grupo) return;
    var veces = Math.max(1, Math.ceil((window.innerWidth * 1.2) / Math.max(grupo.offsetWidth, 1)));
    if (track.dataset.mtVeces === String(veces)) return;
    var molde = grupo.cloneNode(true);
    molde.removeAttribute('aria-hidden');
    track.innerHTML = '';
    for (var i = 0; i < veces * 2; i++) {
      var g = molde.cloneNode(true);
      if (i > 0) g.setAttribute('aria-hidden', 'true');
      track.appendChild(g);
    }
    var dur = parseFloat(getComputedStyle(track.closest('.mt-marquee')).getPropertyValue('--mt-marquee-dur')) || 30;
    track.style.animationDuration = (dur * veces) + 's';
    track.dataset.mtVeces = String(veces);
  }

  function initMarquee() {
    document.querySelectorAll('[data-mt-marquee]').forEach(function (track) {
      if (track.dataset.mtListo) return;
      armarCinta(track);
      track.dataset.mtListo = '1';
      initFreno(track);
    });
  }
  // Si la ventana se agranda, se agregan copias para que la cinta no deje un hueco vacío a la derecha
  var anchoCinta = window.innerWidth, esperaCinta = null;
  window.addEventListener('resize', function () {
    if (window.innerWidth <= anchoCinta) return;
    anchoCinta = window.innerWidth;
    clearTimeout(esperaCinta);
    esperaCinta = setTimeout(function () { document.querySelectorAll('[data-mt-marquee]').forEach(armarCinta); }, 200);
  });

  // Freno con inercia: al pasar el ratón la cinta desacelera hasta detenerse y al salir vuelve a acelerar.
  // Se cambia la velocidad de la animación CSS (sigue en el hilo del compositor), no se mueve nada a mano.
  function initFreno(track) {
    var cinta = track.closest('.mt-marquee');
    if (!cinta || cinta.dataset.mtMarqueeFreno !== '1' || reducido.matches) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches || !track.getAnimations) return;
    var raf = null;
    function anim() { return track.getAnimations()[0]; }
    function suave(t) { return t * t * (3 - 2 * t); } // arranque y llegada suaves (smoothstep)
    function rampa(hacia, ms) {
      var a = anim();
      if (!a) return;
      if (raf) cancelAnimationFrame(raf);
      var desde = a.playbackRate, t0 = performance.now();
      (function paso(ahora) {
        var t = Math.min(1, (ahora - t0) / ms);
        var v = desde + (hacia - desde) * suave(t);
        if (a.updatePlaybackRate) a.updatePlaybackRate(v); else a.playbackRate = v;
        raf = t < 1 ? requestAnimationFrame(paso) : null;
      })(t0);
    }
    cinta.addEventListener('mouseenter', function () { rampa(0, 1100); });
    cinta.addEventListener('mouseleave', function () { rampa(1, 900); });
  }

  // ===== Modo catálogo: "Consultar disponibilidad" por WhatsApp =====
  var waEstado = { eligio: false };
  function tallaElegida() {
    var r = document.querySelector('variant-selects input[type="radio"]:checked');
    if (r) return r.value;
    var s = document.querySelector('variant-selects select');
    return s ? s.value : '';
  }
  function precioActual(fallback) {
    var pr = document.querySelector('product-info .price--on-sale .price-item--sale') || document.querySelector('product-info .price__regular .price-item--regular');
    return pr ? pr.textContent.trim() : fallback;
  }
  function enlaceWhatsApp() {
    var box = document.querySelector('[data-mt-consultar]');
    if (!box) return null;
    var d = box.dataset;
    var talla = (d.unaVariante === 'true' || !waEstado.eligio) ? '' : tallaElegida();
    var tallaTxt = talla ? (d.tallaTexto || 'Talla: {talla}').replace(/\{talla\}/g, talla) : (d.sinTalla || '');
    var msg = (d.plantilla || '')
      .replace(/\{producto\}/g, d.producto || '')
      .replace(/\{talla\}/g, tallaTxt)
      .replace(/\{precio\}/g, precioActual(d.precio || ''))
      .replace(/\{enlace\}/g, d.enlace || location.href)
      .replace(/\n{2,}/g, '\n');
    var cli = window.mtCliente;
    if (cli) msg += '\n\nMi cuenta MATLEON: ' + (cli.nombre || '') + (cli.correo ? ' (' + cli.correo + ')' : '');
    return { href: 'https://wa.me/' + (d.numero || '') + '?text=' + encodeURIComponent(msg), talla: talla };
  }
  function actualizarConsultar() {
    var w = enlaceWhatsApp();
    if (!w) return;
    document.querySelectorAll('[data-mt-consultar-link]').forEach(function (a) { a.href = w.href; });
    var barra = document.querySelector('[data-mt-barra]');
    if (barra) {
      var btn = barra.querySelector('[data-mt-barra-btn]');
      var txt = barra.querySelector('[data-mt-barra-txt]');
      var precio = barra.querySelector('.mt-barra__precio');
      if (btn) btn.href = w.href;
      if (precio) precio.textContent = precioActual(precio.textContent);
      if (txt) {
        var d = barra.dataset;
        txt.textContent = barra.dataset.unaVariante === 'true' ? d.txtAgregar
          : (w.talla ? (d.txtCorto || 'Consultar') + ' ' + (d.txtTalla || 'talla') + ' ' + w.talla : d.txtElegir);
      }
    }
  }
  function initConsultar() {
    var box = document.querySelector('[data-mt-consultar]');
    if (!box || box.dataset.mtListo) return;
    box.dataset.mtListo = '1';
    function marcar(ev) {
      if (ev.target.closest && ev.target.closest('variant-selects')) {
        waEstado.eligio = true;
        actualizarConsultar();
        // La ficha se re-pinta tras cambiar de variante: volvemos a leer la talla y el precio
        setTimeout(actualizarConsultar, 400);
        setTimeout(actualizarConsultar, 1000);
      }
    }
    document.addEventListener('change', marcar);
    document.addEventListener('click', marcar);
    actualizarConsultar();

    // Barra fija: aparece cuando el botón principal ya quedó arriba, fuera de la pantalla
    var barra = document.querySelector('[data-mt-barra]');
    if (barra && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var visible = !e.isIntersecting && e.boundingClientRect.top < 0;
        barra.classList.toggle('mt-barra--visible', visible);
        document.documentElement.classList.toggle('mt-barra-activa', visible);
      }).observe(box);
    }
  }

  // Botón flotante: entra con un pequeño retraso para no competir con la carga de la página
  function initFlotante() {
    var f = document.querySelector('.mt-wa-flotante');
    if (!f || f.dataset.mtListo) return;
    f.dataset.mtListo = '1';
    // En celular, en la portada, espera a que se baje de la apertura (tapaba el texto de la portada)
    var hero = document.querySelector('.mt-rv');
    if (hero && window.matchMedia('(max-width: 749px)').matches && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (e) {
        f.classList.toggle('mt-wa-flotante--visible', !e[0].isIntersecting);
      }, { rootMargin: '0px 0px -55% 0px' });
      io.observe(hero);
      return;
    }
    setTimeout(function () { f.classList.add('mt-wa-flotante--visible'); }, 900);
  }

  // ===== Desplegables (preguntas frecuentes y pestañas de la ficha) =====
  // Animación con la Web Animations API: funciona en cualquier navegador (también Safari de iPhone),
  // se puede interrumpir a medio movimiento y siempre arranca desde la altura que se ve en pantalla.
  var EASE = 'cubic-bezier(0.23, 1, 0.32, 1)';
  function initAcordeones() {
    document.querySelectorAll('details.mt-faq__item, .product__accordion > details, details.mt-ficha__pestana').forEach(function (d) {
      if (d.dataset.mtAcordeon) return;
      var s = d.querySelector(':scope > summary');
      var contenido = s && s.nextElementSibling;
      if (!s || !contenido || !d.animate) return;
      d.dataset.mtAcordeon = '1';
      var anim = null, animContenido = null;

      s.addEventListener('click', function (e) {
        if (reducido.matches) return; // movimiento reducido: comportamiento nativo, sin desplazamiento
        e.preventDefault();
        var desde = d.offsetHeight; // valor actual en pantalla (aunque haya una animación a medias)
        if (anim) anim.cancel();
        if (animContenido) animContenido.cancel();
        var abrir = !d.open || d.classList.contains('mt-cerrando');
        // Medimos ambas alturas sin pintar entre medias (no hay parpadeo)
        var estabaAbierto = d.open;
        d.open = false; var cerrada = d.offsetHeight;
        d.open = true; var abierta = d.offsetHeight;
        d.open = estabaAbierto || abrir;
        d.style.overflow = 'hidden';

        if (abrir) {
          d.classList.remove('mt-cerrando');
          d.open = true;
          anim = d.animate([{ height: desde + 'px' }, { height: abierta + 'px' }], { duration: 320, easing: EASE });
          animContenido = contenido.animate(
            [{ opacity: 0, transform: 'translateY(-6px)' }, { opacity: 1, transform: 'none' }],
            { duration: 280, delay: 40, easing: EASE, fill: 'backwards' }
          );
        } else {
          d.classList.add('mt-cerrando');
          anim = d.animate([{ height: desde + 'px' }, { height: cerrada + 'px' }], { duration: 240, easing: EASE });
          animContenido = contenido.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 160, easing: 'ease-out', fill: 'forwards' });
        }
        var esta = anim;
        anim.onfinish = function () {
          if (anim !== esta) return;
          if (!abrir) { d.open = false; d.classList.remove('mt-cerrando'); }
          if (animContenido) { animContenido.cancel(); animContenido = null; }
          d.style.overflow = '';
          anim = null;
        };
      });
    });
  }

  // Accesos a la vitrina Premium de la categoría (#mt-premium): desplazamiento suave, dejando ver la cabecera
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-mt-a-premium]');
    var dest = a && document.getElementById('mt-premium');
    if (!dest) return;
    e.preventDefault();
    var cab = document.querySelector('.section-header');
    var y = dest.getBoundingClientRect().top + window.scrollY - (cab ? cab.offsetHeight : 0);
    window.scrollTo({ top: y, behavior: reducido.matches ? 'auto' : 'smooth' });
  });

  // Fotos de tarjeta nítidas: el "sizes" de Dawn supone 2-4 columnas, pero la tarjeta sale más ancha
  // (vitrinas, categorías con pocas piezas) y el navegador bajaba una foto chica. Se le dice su ancho real.
  var roFotos = 'ResizeObserver' in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (e) {
      var w = Math.ceil(e.contentRect.width);
      if (w > 0 && e.target.sizes !== w + 'px') e.target.sizes = w + 'px';
    });
  }) : null;
  function initFotosTarjeta() {
    if (!roFotos) return;
    document.querySelectorAll('.card__media img[srcset]').forEach(function (img) {
      if (img.mtAncho) return;
      img.mtAncho = true;
      roFotos.observe(img);
    });
  }
  // Las rejillas que llegan después (filtros, "cargar más") también se vigilan
  if (roFotos && 'MutationObserver' in window) {
    new MutationObserver(function (cambios) {
      for (var i = 0; i < cambios.length; i++) if (cambios[i].addedNodes.length) { initFotosTarjeta(); return; }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() { initMarquee(); initReveal(); initConsultar(); initFlotante(); initAcordeones(); initFotosTarjeta(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();